const DEFAULT_TABLE_PAGE_SIZE = 20;
const DEFAULT_TABLE_PAGE_SIZE_KEY = "esfDefaultTablePageSize";
const VALID_TABLE_PAGE_SIZES = [5, 10, 20, 30, 40, 50];

function normalizePageSize(value, fallback = DEFAULT_TABLE_PAGE_SIZE) {
  const numericValue = Number(value);
  return VALID_TABLE_PAGE_SIZES.includes(numericValue) ? numericValue : fallback;
}

function readStoredPageSize() {
  if (typeof localStorage === "undefined") return null;
  return normalizePageSize(localStorage.getItem(DEFAULT_TABLE_PAGE_SIZE_KEY), null);
}

export function setDefaultTablePageSize(value) {
  const pageSize = normalizePageSize(value, null);
  if (typeof localStorage === "undefined") return pageSize;
  if (!pageSize) {
    localStorage.removeItem(DEFAULT_TABLE_PAGE_SIZE_KEY);
    return null;
  }
  localStorage.setItem(DEFAULT_TABLE_PAGE_SIZE_KEY, String(pageSize));
  return pageSize;
}

export function getDefaultTablePageSize(fallback = DEFAULT_TABLE_PAGE_SIZE) {
  return readStoredPageSize() || normalizePageSize(fallback);
}

export function createTablePagination(overrides = {}) {
  const perPage = normalizePageSize(
    overrides.per_page ?? overrides.perPage ?? getDefaultTablePageSize()
  );

  return {
    total: 0,
    current_page: 1,
    per_page: perPage,
    last_page: 1,
    ...overrides,
    _default_per_page: perPage
  };
}

export function applyDefaultTablePageSize(pagination) {
  if (!pagination) return DEFAULT_TABLE_PAGE_SIZE;

  const nextDefault = getDefaultTablePageSize();
  const previousDefault = Number(pagination._default_per_page || 0);
  const current = Number(pagination.per_page || 0);

  if (!current || !previousDefault || current === previousDefault) {
    pagination.per_page = nextDefault;
  }

  pagination._default_per_page = nextDefault;
  return pagination.per_page;
}

export function preserveDefaultPageSizeMarker(nextPagination, currentPagination) {
  return {
    ...nextPagination,
    _default_per_page: currentPagination?._default_per_page || getDefaultTablePageSize()
  };
}
